import store from '../store/index';
import ApiService from './ApiService';

export const login = (email: string, password: string) => {
  return ApiService.post('/parse/login', { username: email, password }, true);
};

export const logout = () => {
  return ApiService.post('/parse/logout', {});
};

export const getCurrent = (sessionToken?: string) => {
  return ApiService.get('/parse/users/me', sessionToken);
};

export const getSessionToken = (): Promise<string> => {
  return new Promise((resolve) => {
    if (store.state.auth.currentUser && store.state.auth.currentUser.sessionToken) {
      resolve(store.state.auth.currentUser.sessionToken);
    } else {
      store.watch((state) => state.auth.currentUser, (newValue) => {
        if (newValue && newValue.sessionToken) {
          resolve(newValue.sessionToken);
        }
      });
    }
  });
};

export const afterLogin = async () => {
  await Promise.all([
    store.dispatch('loadRetailer'),
    store.dispatch('loadRoles'),
  ]);
};

const AuthService = {
  login, logout, getCurrent, getSessionToken, afterLogin,
};

export default AuthService;
